import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/life-insurance-needs',
  component: () => import('../../routes/LifeInsurance.svelte'),
  card: {
    id: 'life-insurance-needs',
    title: 'Life Insurance Needs',
    description: 'Calculate how much life insurance you need using the DIME method for family protection.',
    icon: 'security',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/life-insurance-needs',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Life Insurance Needs Calculator – DIME Method Coverage Calculator',
    description: "Free life insurance calculator using the DIME method. Calculate how much life insurance you need based on debt, income replacement, mortgage payoff, and children's education costs. Find the right coverage to protect your family.",
  },
};

export default meta;
